var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73283 0.560492C9.09193 0.201521 9.57893 -9.37393e-05 10.0867 3.26957e-08C10.5944 9.38047e-05 11.0814 0.201888 11.4403 0.560992C11.7993 0.920095 12.0009 1.40709 12.0008 1.91485C12.0007 2.4226 11.7989 2.90952 11.4398 3.26849L10.7068 4.00249L7.99883 1.29449L8.73283 0.561492V0.560492ZM7.29283 2.00149L1.33683 7.95549C1.15604 8.13641 1.01979 8.35688 0.938829 8.59949L0.0248294 11.3425C-0.00462013 11.4306 -0.00895861 11.5251 0.0123002 11.6155C0.0335591 11.7059 0.0795751 11.7886 0.145191 11.8543C0.210806 11.92 0.293428 11.9662 0.383797 11.9876C0.474165 12.009 0.568708 12.0048 0.656829 11.9755L3.39983 11.0605C3.64283 10.9805 3.86283 10.8435 4.04383 10.6625L9.99983 4.70949L7.29183 2.00049L7.29283 2.00149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.b709543bc7636bc7f7afbbe0645ab55d.svg";
export { ForwardRef as ReactComponent };